import React from "react";
import styles from "./CommandModals.module.scss";
import { IModalInstance } from "@whatslly/ui-components/modals/ModalProvider";
import { MessageModal } from "@whatslly/ui-components/modals/MessageModal";
import { TextInputWithCopy } from "@whatslly/ui-components/v2/TextInputWithCopy";
import { useTranslation } from "react-i18next";

interface ISharePairingUrl extends IModalInstance {
  pairingUrl: string;
  created?: boolean;
}

export const SharePairingUrlModal: React.FC<ISharePairingUrl> = ({ closeModal, pairingUrl, created }) => {
  const { t } = useTranslation();
  return (
    <MessageModal
      okTestId="share-pairing-url-modal-ok"
      bodyClassName={styles.sharePairingUrlModal}
      closeModal={closeModal}
      title={t(created ? "sidecars.sidecar_created" : "sidecars.invitation_sent")}
    >
      <div className={styles.inputLabel}>{t("sidecars.share_invite_link")}</div>
      <TextInputWithCopy value={pairingUrl} disabled={true} />
    </MessageModal>
  );
};
